/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of roles in the system */
export enum RoleType {
  Administrative,
  Operational,
  ReadOnly,
  Compliance,
  Emergency,
  Custom,
  Service,
  Guest,
}

export type RoleTypeArgs = RoleType;

export function getRoleTypeEncoder(): FixedSizeEncoder<RoleTypeArgs> {
  return getEnumEncoder(RoleType);
}

export function getRoleTypeDecoder(): FixedSizeDecoder<RoleType> {
  return getEnumDecoder(RoleType);
}

export function getRoleTypeCodec(): FixedSizeCodec<RoleTypeArgs, RoleType> {
  return combineCodec(getRoleTypeEncoder(), getRoleTypeDecoder());
}
